import { render, staticRenderFns } from "./LmTitle.vue?vue&type=template&id=77567e72&"
import script from "./LmTitle.vue?vue&type=script&lang=js&"
export * from "./LmTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports